'use client'

const useSurveyAnswer = () => {
  const prefix = 'surveyId.'

  const setSurveyAnswer = (surveyId: string, answer: object) => {
    localStorage.setItem(prefix + surveyId, JSON.stringify(answer))
  }

  const getSurveyAnswers = (surveyId: string = '', withDelete: boolean = false) => {
    let answers: Record<string, Record<string, { surveyOptionId: string }[]>> = {}
    Object.keys(localStorage).forEach((key) => {
      if (key.startsWith(`${prefix}${surveyId}`)) {
        const newKey = key.slice(`${prefix}`.length)
        answers = { ...answers, [newKey]: JSON.parse(localStorage.getItem(key)!) }

        if (withDelete) {
          localStorage.removeItem(key)
        }
      }
    })

    return answers
  }

  return {
    getSurveyAnswers,
    setSurveyAnswer,
  }
}

export default useSurveyAnswer
